const _map = {};

const modules = require.context('./', true, /[A-Z$]\/index\.js$/);

/**
 * Auto-scan plan modules and set key property
 *
 * Note: Key Definition and Override Behavior
 * ===========================================
 * This code sets `key` to the directory name (e.g., 'LARGE_MEETING', 'CMR').
 * All plan mixins also define `key` using planTypes[planTypes.XXX] which returns the key name
 * (e.g., 'LARGE_MEETING', 'CMR') - the same as the directory name.
 *
 * Execution Order & Override:
 * 1. This code runs first: sets key = 'LARGE_MEETING' (directory name)
 * 2. Component definition with mixin: sets key = planTypes[planTypes.LARGE_MEETING] = 'LARGE_MEETING' (key name)
 * 3. Result: Mixin value OVERRIDES this value (Vue mixin merge strategy), but values are identical
 *
 * Final State:
 * - _map['LARGE_MEETING'] can find the plan (via directory name as map key)
 * - plan.key and $options.key = 'LARGE_MEETING' (mixin value, same as directory name)
 * - Both auto-scan and mixin use the same key name format, ensuring consistency
 *
 * See: src/plans/LARGE_MEETING/mixin.js, src/plans/CMR/mixin.js for mixin key definitions
 * All mixins now use planTypes[planTypes.XXX] format to get the key name (not the value)
 */
modules.keys().map((key) => {
    const name = key.split('/')[1];
    modules(key).default.key = name;
    const components = modules(key).default?.components ?? {};
    Object.values(components).forEach(x => x && (x.key = name));
    _map[name] = modules(key).default;
});

export default _map;
